import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const StationContext = createContext(null);
const LS_KEY = "fuelops_active_station_id";

export function StationProvider({ children }) {
  const [stations, setStations] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const list = await api.listStations();
    setStations(list);
    const saved = localStorage.getItem(LS_KEY);
    const next =
      list.find((s) => s.id === saved)?.id || (list[0] && list[0].id) || null;
    setActiveId(next);
    if (next) localStorage.setItem(LS_KEY, next);
    setLoading(false);
    return list;
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setActive = (id) => {
    setActiveId(id);
    localStorage.setItem(LS_KEY, id);
  };

  const active = stations.find((s) => s.id === activeId) || null;

  return (
    <StationContext.Provider
      value={{ stations, activeId, active, setActive, refresh, loading }}
    >
      {children}
    </StationContext.Provider>
  );
}

export const useStation = () => useContext(StationContext);
